import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationDepartmentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Department/DepartmentBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationDepartment"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationDepartment"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationDepartmentActivity)
